<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent taskContainer">
  <mat-expansion-panel expanded="false" id="headerContent">
    <mat-expansion-panel-header>
      <h1 id="title">{{translation.HomeDeliveryCardTitle}}-{{translation.TransportOrder}}</h1>
    </mat-expansion-panel-header>
    <div id="clientContent">
      <div id="addressContent">
        <mat-card>
          <div class="line">
            <p>{{translation.Client + ':'}}</p>
            <p>{{order.Client.Name}}</p>
          </div>
          <div class="line">
            <p>{{translation.Contact + ':'}}</p>
            <p>{{order.Client.Contact}}</p>
          </div>
          <div class="line">
            <p>{{translation.Email + ':'}}</p>
            <p>{{order.Client.Email}}</p>
          </div>
          <div class="line">
            <p>{{translation.Phone + ':'}}</p>
            <p>{{order.Client.Phone}}</p>
          </div>
          <div class="line">
            <p>{{translation.AddressLine1 + ':'}}</p>
            <p>{{order.Client.AddressLine1}}</p>
          </div>
          <div class="line" *ngIf="order.Client.AddressLine2 != ''">
            <p>{{translation.AddressLine2 + ':'}}</p>
            <p>{{order.Client.AddressLine2}}</p>
          </div>
          <div class="line">
            <p>{{translation.ZipAndCity + ':'}}</p>
            <p>{{order.Client.Zip + ' ' + order.Client.City + ' (' + order.Client.Region + ')'}}</p>
          </div>
        </mat-card>
      </div>
      <div id="logoContent">
        <img src="../../../../assets/logos/logo_weiss.jpg" alt="CotraLogo" id="logo"/>
      </div>
    </div>
  </mat-expansion-panel>
  <form>
    <mat-stepper orientation="horizontal" #stepper id="stepper" selectedIndex="{{this.stepper.selectedIndex}}">
      <mat-step state="number">
        <ng-template matStepLabel>{{translation.Sender}}</ng-template>
        <mat-card class="formCard">
          <div class="headerContent">
            <mat-radio-group name="senderRadioButtonGroup" class="addressRadioButtonContent">
              <mat-radio-button class="addressRadioButton" name="senderFreeDataRadio" color="primary" value="0" (change)="senderChangeToFreeData()" checked>{{translation.FreeText}}</mat-radio-button>
              <mat-radio-button class="addressRadioButton" name="senderSelfDataRadio" color="primary" value="1" (change)="senderChangeToSelfData()">{{translation.OwnAddress}}</mat-radio-button>
              <mat-radio-button class="addressRadioButton" name="senderCoreDataRadio" color="primary" value="2" (change)="senderChangeToCoreData()">{{translation.CoreData}}</mat-radio-button>
            </mat-radio-group>
            <div class="buttonContent">
              <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
            </div>
          </div>
          <div class="inputContent">
            <mat-form-field class="fieldForm" *ngIf="senderDropDownIsVisible">
              <mat-icon matPrefix>search</mat-icon>
              <input type="text" placeholder="{{translation.ChooseSender}}" matInput [formControl]="autoCompleteSender" [matAutocomplete]="autoSender" (ngModelChange)="onSenderSelectChange($event)" required>
              <mat-autocomplete #autoSender="matAutocomplete">
                <mat-option *ngFor="let sender of filteredSenderList | async" [value]="sender.PartnerAid">{{sender.Description}}, {{sender.DeliveryAddition}}, {{sender.DeliveryStreet}}, {{sender.DeliveryZip}}, {{sender.DeliveryCity}}</mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="senderName" matInput placeholder="{{translation.Sender}}" [(ngModel)]="order.Sender.Name" required [disabled]="disabledSenderFields1" maxlength="100">
            </mat-form-field>
            <div class="customLine">
              <mat-form-field class="fieldForm">
                <input name="senderContact" matInput placeholder="{{translation.Contact}}" [(ngModel)]="order.Sender.Contact" required [disabled]="disabledSenderFields2" maxlength="200">
              </mat-form-field>
              <mat-form-field class="fieldForm">
                <mat-select [(ngModel)]="order.Sender.Notification" name="senderNotification" placeholder="{{translation.Notification}}" required>
                  <mat-option *ngFor="let notification of notifications" [value]="notification.value">{{notification.value}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-form-field class="fieldForm">
              <input name="senderEmail" matInput placeholder="{{translation.Email}}" [(ngModel)]="order.Sender.Email" required [disabled]="disabledSenderFields2" maxlength="100">
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="senderPhone" matInput placeholder="{{translation.Phone}}" [(ngModel)]="order.Sender.Phone" required [disabled]="disabledSenderFields2" maxlength="30">
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="senderAddressLine1" matInput placeholder="{{translation.AddressLine1}}" [(ngModel)]="order.Sender.AddressLine1" required [disabled]="disabledSenderFields1" maxlength="50">
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="senderAddressLine2" matInput placeholder="{{translation.AddressLine2}}" [(ngModel)]="order.Sender.AddressLine2" [disabled]="disabledSenderFields1" maxlength="50">
            </mat-form-field>
            <div class="customLine">
              <mat-form-field class="fieldForm" *ngIf="senderIsFreeData" [floatLabel]="senderFloatLabelControl.value">
                <input type="text" name="senderSearch" placeholder="{{translation.City}} {{translation.Or}} {{translation.Zip}}" matInput [formControl]="autoCompleteSenderSearch" [matAutocomplete]="autoSenderSearch" [(ngModel)]="senderSearchText">
                <mat-autocomplete #autoSenderSearch="matAutocomplete">
                  <mat-option *ngFor="let senderSearch of filteredSenderSearchList | async" (onSelectionChange)="onSenderSearch($event, senderSearch)" [value]="">{{senderSearch.City}} ({{senderSearch.Zip}})</mat-option>
                </mat-autocomplete>
                <mat-label><mat-icon>search</mat-icon>&nbsp;{{translation.Search}}</mat-label>
              </mat-form-field>
              <mat-form-field class="fieldForm">
                <input name="senderZip" matInput placeholder="{{translation.Zip}}" [(ngModel)]="order.Sender.Zip" required [disabled]="disabledSenderFields1" maxlength="10">
              </mat-form-field>
              <mat-form-field class="fieldForm">
                <input name="senderCity" matInput placeholder="{{translation.City}}" [(ngModel)]="order.Sender.City" required [disabled]="disabledSenderFields1" maxlength="50">
              </mat-form-field>
            </div>
            <div class="customLine">

              <mat-form-field class="fieldForm">
                <input
                  #elementToFocusSender name="senderDate" matInput required
                  placeholder="{{senderIsFreeData ? translation.ReadyForPickUp : translation.ReadyForCollection}}"
                  [matDatepicker]="senderPicker" [(ngModel)]="tempSenderDate" [min]="minDate"
                  (focus)="openSenderDatePicker(senderPicker)" (click)="openSenderDatePicker(senderPicker)">
                <mat-datepicker-toggle matSuffix [for]="senderPicker"></mat-datepicker-toggle>
                <mat-datepicker #senderPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="fieldForm" *ngIf="senderIsFreeData">
                <mat-label>{{translation.Time}}</mat-label>
                <mat-select name="pickupTime" required [(ngModel)]="order.Sender.PickUpTimeText">
                  <mat-option *ngFor="let pickupTime of times" [value]="pickupTime.value">{{pickupTime.value}}</mat-option>
                </mat-select>
              </mat-form-field>

            </div>
            <mat-form-field class="fieldForm">
              <textarea name="senderComment" matInput placeholder="{{translation.Comment}}" [(ngModel)]="order.Sender.Comment" rows="4" maxlength="500"></textarea>
            </mat-form-field>
          </div>
          <div class="footerContent">
            <div class="buttonContent">
              <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
            </div>
          </div>
        </mat-card>
      </mat-step>
      <mat-step state="number">
        <ng-template matStepLabel>{{translation.Recipient}}</ng-template>
        <mat-card class="formCard">
          <div class="headerContent">
            <mat-radio-group name="recipientRadioButtonGroup" class="addressRadioButtonContent">
              <mat-radio-button class="addressRadioButton" name="recipientFreeDataRadio" color="primary" value="0" (change)="recipientChangeToFreeData()" [disabled]="senderIsFreeData" [checked]="!senderIsFreeData">{{translation.FreeText}}</mat-radio-button>
              <mat-radio-button class="addressRadioButton" name="recipientSelfDataRadio" color="primary" value="1" (change)="recipientChangeToSelfData()" [disabled]="!senderIsFreeData" [checked]="senderIsFreeData">{{translation.OwnAddress}}</mat-radio-button>
              <mat-radio-button class="addressRadioButton" name="recipientCoreDataRadio" color="primary" value="2" (change)="recipientChangeToCoreData()" [disabled]="!senderIsFreeData">{{translation.CoreData}}</mat-radio-button>
            </mat-radio-group>
            <div class="buttonContent">
              <button type="button" mat-button (click)="back()">{{translation.Back}}</button>
              <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
            </div>
          </div>
          <div class="inputContent">
            <mat-form-field class="fieldForm" [style.display]="recipientDropDownIsVisible ? 'block' : 'none'">
              <input type="text" placeholder="{{translation.ChooseRecipient}}" matInput [formControl]="autoCompleteRecipient" [matAutocomplete]="autoRecipient" (ngModelChange)="onRecipientSelectChange($event)" required>
              <mat-autocomplete #autoRecipient="matAutocomplete">
                <mat-option *ngFor="let recipient of filteredRecipientList | async" [value]="recipient.PartnerAid">{{recipient.Description}}, {{recipient.DeliveryAddition}}, {{recipient.DeliveryStreet}}, {{recipient.DeliveryCity}}</mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="recipientName" matInput placeholder="{{translation.Recipient}}" [(ngModel)]="order.Recipient.Name" required [disabled]="disabledRecipientFields1" maxlength="100">
            </mat-form-field>
            <div class="customLine">
              <mat-form-field class="fieldForm">
                <input name="recipientContact" matInput placeholder="{{translation.Contact}}" [(ngModel)]="order.Recipient.Contact" required [disabled]="disabledRecipientFields2" maxlength="200">
              </mat-form-field>
              <mat-form-field class="fieldForm">
                <mat-label>{{translation.Notification}}</mat-label>
                <mat-select name="recipientNotification" required [(ngModel)]="order.Recipient.Notification">
                  <mat-option *ngFor="let notification of notifications" [value]="notification.value">{{notification.value}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-form-field class="fieldForm">
              <input name="recipientEmail" matInput placeholder="{{translation.Email}}" [(ngModel)]="order.Recipient.Email" required [disabled]="disabledRecipientFields2" maxlength="100">
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="recipientPhone" matInput placeholder="{{translation.Phone}}" [(ngModel)]="order.Recipient.Phone" required [disabled]="disabledRecipientFields2" maxlength="30">
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="recipientAddressLine1" matInput placeholder="{{translation.AddressLine1}}" [(ngModel)]="order.Recipient.AddressLine1" required [disabled]="disabledRecipientFields1" maxlength="50">
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="recipientAddressLine2" matInput placeholder="{{translation.AddressLine2}}" [(ngModel)]="order.Recipient.AddressLine2" [disabled]="disabledRecipientFields1" maxlength="50">
            </mat-form-field>
            <div class="customLine">
              <mat-form-field class="fieldForm" *ngIf="recipientIsFreeData" [floatLabel]="recipientFloatLabelControl.value">
                <input type="text" name="recipientSearch" placeholder="{{translation.City}} {{translation.Or}} {{translation.Zip}}" matInput [formControl]="autoCompleteRecipientSearch" [matAutocomplete]="autoRecipientSearch" [(ngModel)]="recipientSearchText">
                <mat-autocomplete #autoRecipientSearch="matAutocomplete">
                  <mat-option *ngFor="let recipientSearch of filteredRecipientSearchList | async" (onSelectionChange)="onRecipientSearch($event, recipientSearch)" [value]="">{{recipientSearch.City}} ({{recipientSearch.Zip}})</mat-option>
                </mat-autocomplete>
                <mat-label><mat-icon>search</mat-icon>&nbsp;{{translation.Search}}</mat-label>
              </mat-form-field>
              <mat-form-field class="fieldForm">
                <input name="recipientZip" matInput placeholder="{{translation.Zip}}" [(ngModel)]="order.Recipient.Zip" required [disabled]="disabledRecipientFields1" maxlength="10">
              </mat-form-field>
              <mat-form-field class="fieldForm">
                <input name="recipientCity" matInput placeholder="{{translation.City}}" [(ngModel)]="order.Recipient.City" required [disabled]="disabledRecipientFields1" maxlength="50">
              </mat-form-field>
            </div>
            <div class="customLine">

              <mat-form-field class="fieldForm" *ngIf="!senderIsFreeData">
                <input name="deliveryDate" matInput [matDatepicker]="recipientPicker" placeholder="{{translation.DeliverOn}}" [(ngModel)]="tempRecipientDate" [min]="minDate" (focus)="openRecipientDatePicker(recipientPicker)" (click)="openRecipientDatePicker(recipientPicker)" required #elementToFocusRecipient>
                <mat-datepicker-toggle matSuffix [for]="recipientPicker"></mat-datepicker-toggle>
                <mat-datepicker #recipientPicker></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="fieldForm" *ngIf="!senderIsFreeData">
                <mat-label>{{translation.Time}}</mat-label>
                <mat-select name="deliveryTime" required [(ngModel)]="order.Recipient.DeliveryTimeText">
                  <mat-option *ngFor="let deliveryTime of times" [value]="deliveryTime.value">{{deliveryTime.value}}</mat-option>
                </mat-select>
              </mat-form-field>

            </div>
            <mat-form-field class="fieldForm">
              <textarea name="recipientComment" matInput placeholder="{{translation.Comment}}" [(ngModel)]="order.Recipient.Comment" rows="4" maxlength="500"></textarea>
            </mat-form-field>
          </div>
          <div class="footerContent">
            <div class="buttonContent">
              <button type="button" mat-button (click)="back()">{{translation.Back}}</button>
              <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
            </div>
          </div>
        </mat-card>
      </mat-step>
      <mat-step state="number">
        <ng-template matStepLabel>{{translation.Vehicle}}</ng-template>
        <mat-card class="formCard">
          <div class="headerContent">
            <button mat-mini-fab class="vehicleButton green" type="button" (click)="addVehicle()" matTooltip="{{translation.AddAdditionalVehicle}}" matTooltipShowDelay="500">
              <span class="material-icons">add</span>
            </button>
            <button mat-mini-fab class="vehicleButton red" type="button" [disabled]="tabs.length === 1" (click)="removeVehicle()" matTooltip="{{translation.DeleteThisVehicle}}" matTooltipShowDelay="500">
              <mat-icon>delete</mat-icon>
            </button>
            <div class="buttonContent">
              <button type="button" mat-button (click)="back()">{{translation.Back}}</button>
              <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
            </div>
          </div>
          <mat-checkbox *ngIf="isAmagUser" [checked]="disabledVehicleFields !== 'false'" (change)="toggleAmagFields()" color="primary">AMAG-{{translation.Vehicle}}</mat-checkbox>
          <div class="inputContent">
            <mat-tab-group [selectedIndex]="selectedVehicle.value" (selectedIndexChange)="selectedVehicle.setValue($event)">
              <mat-tab *ngFor="let tab of tabs; let index = index" [label]="tab">
                <div class="listContent" *ngIf="!isAmagUser">
                  <mat-form-field>
                    <input type="text" placeholder="{{translation.ChooseModel}}" matInput [formControl]="autoCompleteModelList[this.selectedVehicle.value]" [matAutocomplete]="autoModel" required>
                    <mat-autocomplete #autoModel="matAutocomplete" [displayWith]="getDisplayFn()">
                      <mat-option *ngFor="let model of filteredModelList | async" [value]="model" (onSelectionChange)="selectModel(model)">{{model.UnitRemark}}</mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field class="fieldForm">
                    <input #chassis="ngModel" name="chassisNumber" matInput placeholder="{{translation.ChassisNumber}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].ChassisNumber" required minlength="17" maxlength="17">
                    <div *ngIf="chassis.invalid && (chassis.dirty || chassis.touched)" class="alert">
                      <div *ngIf="chassis.errors.minlength">{{translation.MustBeSeventeenDigits}}</div>
                    </div>
                  </mat-form-field>
                  <mat-form-field class="fieldForm">
                    <input name="commissionNumber" matInput placeholder="{{translation.CommissionNumber}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].CommissionNumber" maxlength="50">
                  </mat-form-field>
                  <mat-form-field class="fieldForm">
                    <input name="license" matInput placeholder="{{translation.Mark}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].License" maxlength="50">
                  </mat-form-field>
                  <mat-form-field class="fieldForm">
                    <input name="color" matInput placeholder="{{translation.Color}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].Color" maxlength="1000">
                  </mat-form-field>
                  <mat-form-field class="fieldForm">
                    <textarea name="Comment" matInput placeholder="{{translation.Remarks}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].Comment" rows="4" maxlength="499"></textarea>
                  </mat-form-field>
                  <label class="specialLabel">{{translation.Special}} *</label>
                  <mat-checkbox *ngFor="let special of order.VehicleList[+selectedVehicle.value].SpecialSelects"
                                [checked]="special.Selected"
                                [disabled]="special.Disabled"
                                (change)="specialCheckboxChange($event, special)"
                                color="primary"
                                class="specialCheckboxes">
                    {{special.Value}}
                  </mat-checkbox>
                  <mat-form-field class="fieldForm" *ngIf="order.VehicleList[+this.selectedVehicle.value].SpecialTextActive">
                    <textarea name="special" matInput placeholder="{{translation.PleaseDescribeSpecial}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].SpecialComment" rows="4" required maxlength="850"></textarea>
                  </mat-form-field>
                </div>
                <div class="listContent" *ngIf="isAmagUser">
                  <mat-form-field class="fieldForm">
                    <input name="commissionNum" matInput placeholder="{{translation.CommissionNumber}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].CommissionNumber" (change)="getAmagVehicleData()" maxlength="50">
                  </mat-form-field>
                  <mat-form-field class="fieldForm" *ngIf="disabledVehicleFields !== 'false'">
                    <input name="model" matInput placeholder="{{translation.Model}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].ModelName" maxlength="50" [disabled]="disabledVehicleFields">
                  </mat-form-field>
                  <mat-form-field *ngIf="disabledVehicleFields === 'false'">
                    <input type="text" placeholder="{{translation.ChooseModel}}" matInput [formControl]="autoCompleteModelList[this.selectedVehicle.value]" [matAutocomplete]="autoModel" required>
                    <mat-autocomplete #autoModel="matAutocomplete" [displayWith]="getDisplayFn()">
                      <mat-option *ngFor="let model of filteredModelList | async" [value]="model" (onSelectionChange)="selectModel(model)">{{model.UnitRemark}}</mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field class="fieldForm">
                    <input #chassis="ngModel" name="chassis" matInput placeholder="{{translation.ChassisNumber}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].ChassisNumber" [disabled]="disabledVehicleFields" required minlength="17" maxlength="17">
                    <div *ngIf="chassis.invalid && (chassis.dirty || chassis.touched)" class="alert">
                      <div *ngIf="chassis.errors.minlength">{{translation.MustBeSeventeenDigits}}</div>
                    </div>
                  </mat-form-field>
                  <mat-form-field class="fieldForm">
                    <input name="color" matInput placeholder="{{translation.Color}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].Color" [disabled]="disabledVehicleFields" maxlength="1000">
                  </mat-form-field>
                  <mat-form-field class="fieldForm">
                    <input name="mark" matInput placeholder="{{translation.Mark + ' (' + translation.MarkAddition + ')' }})" [(ngModel)]="order.VehicleList[+selectedVehicle.value].License" maxlength="50">
                  </mat-form-field>
                  <mat-form-field class="fieldForm">
                    <textarea name="remarks" matInput placeholder="{{translation.Remarks}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].Comment" rows="4" maxlength="499"></textarea>
                  </mat-form-field>
                  <label class="specialLabel">{{translation.Special}} *</label>
                  <mat-checkbox *ngFor="let special of order.VehicleList[+selectedVehicle.value].SpecialSelects"
                                [checked]="special.Selected"
                                [disabled]="special.Disabled"
                                (change)="specialCheckboxChange($event, special)"
                                color="primary"
                                class="specialCheckboxes">
                    {{special.Value}}
                  </mat-checkbox>
                  <mat-form-field class="fieldForm" *ngIf="order.VehicleList[+this.selectedVehicle.value].SpecialTextActive">
                    <textarea name="special" matInput placeholder="{{translation.PleaseDescribeSpecial}}" [(ngModel)]="order.VehicleList[+selectedVehicle.value].SpecialComment" rows="4" required maxlength="850"></textarea>
                  </mat-form-field>
                  <div>
                    <div id="uploadContent" appDnd class="row dropZone" (fileDropped)="onFileDropped($event)">
                      <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowserHandler($event.target.files)">
                      <img src="../../../../assets/images/uploadFile.svg" alt="uploadFile">
                      <h3>{{translation.DragAndDropFileHere}}</h3>
                      <h3>{{translation.Or}}</h3>
                      <label id="fileDropButton" class="mat-button" for="fileDropRef">{{translation.BrowseForFile}}</label>
                    </div>
                    <div class="files-list">
                      <div class="single-file" *ngFor="let file of files; let i = index">
                        <img src="../../../../assets/images/file.svg" width="45px" alt="file">
                        <div class="info">
                          <h4 class="name">{{file?.name}}</h4>
                          <p class="size">{{formatBytes(file?.size)}}</p>
                          <app-progress [progress]="file?.progress"></app-progress>
                        </div>
                        <img src="../../../../assets/images/deleteFile.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
          <div class="footerContent">
            <div class="buttonContent">
              <button type="button" mat-button (click)="back()">{{translation.Back}}</button>
              <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
            </div>
          </div>
        </mat-card>
      </mat-step>
      <mat-step state="number">
        <div class="siteMargin">
          <ng-template matStepLabel>{{translation.Confirm}}</ng-template>
          <div class="summaryCards">
            <mat-card class="summaryCard">
              <mat-card-content class="summaryCardContent">
                <mat-card-title class="summaryCardTitle">{{translation.Client}}</mat-card-title>
                <mat-card-subtitle class="addressLine">{{order.Client.Name}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine">{{order.Client.AddressLine1}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine" *ngIf="order.Client.AddressLine2 != ''">{{order.Client.AddressLine2}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine">{{order.Client.Zip}} {{order.Client.City}}</mat-card-subtitle>
                <mat-card-subtitle class="lastLine">
                  <mat-radio-group name="freightPayerRadioGroup">
                    <mat-radio-button class="matRadioButtonCustom" #clientRadio name="clientRadio" value="0" (change)="changeFreightPayer(0)" color="primary" checked>{{translation.FreightPayer}}</mat-radio-button>
                  </mat-radio-group>
                </mat-card-subtitle>
                <mat-card-subtitle *ngIf="order.FreightPayerSelection === 0">
                  <mat-label>{{translation.ChoosePartner}}</mat-label>
                  <mat-select [(value)]="selectedAid">
                    <mat-option *ngFor="let partner of partnerList" [value]="partner">{{partner}}</mat-option>
                  </mat-select>
                </mat-card-subtitle>
              </mat-card-content>
            </mat-card>
            <mat-card class="summaryCard middleCard">
              <mat-card-content class="summaryCardContent">
                <mat-card-title class="summaryCardTitle">{{translation.Sender}}</mat-card-title>
                <mat-card-subtitle class="addressLine">{{order.Sender.Name}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine">{{order.Sender.AddressLine1}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine" *ngIf="order.Sender.AddressLine2 != ''">{{order.Sender.AddressLine2}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine">{{order.Sender.Zip}} {{order.Sender.City}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine">
                  {{translation.ReadyForCollection}}: {{this.order.Sender.Selection == 1 ? this.translation.On : this.translation.AsOf}} {{this.order.Sender.PickUpDateText}} {{this.order.Sender.Selection == 1 ? this.order.Sender.PickUpTimeText : ''}}
                </mat-card-subtitle>
                <mat-card-subtitle class="lastLine" *ngIf="!senderIsFreeData">
                  <mat-radio-group name="freightPayerRadioGroup">
                    <mat-radio-button class="matRadioButtonCustom" name="senderRadio" value="1" (change)="changeFreightPayer(1)" color="primary">{{translation.FreightPayer}}</mat-radio-button>
                  </mat-radio-group>
                </mat-card-subtitle>
              </mat-card-content>
            </mat-card>
            <mat-card class="summaryCard">
              <mat-card-content class="summaryCardContent">
                <mat-card-title class="summaryCardTitle">{{translation.Recipient}}</mat-card-title>
                <mat-card-subtitle class="addressLine">{{order.Recipient.Name}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine">{{order.Recipient.AddressLine1}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine" *ngIf="order.Recipient.AddressLine2 != ''">{{order.Recipient.AddressLine2}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine">{{order.Recipient.Zip}} {{order.Recipient.City}}</mat-card-subtitle>
                <mat-card-subtitle class="addressLine" *ngIf="order.Recipient.Selection == 1">{{this.translation.DeliveryDate}} {{this.translation.On}} {{this.order.Recipient.DeliveryDateText}} {{this.order.Recipient.DeliveryTimeText}}</mat-card-subtitle>
                <mat-card-subtitle class="lastLine" *ngIf="!recipientIsFreeData">
                  <mat-radio-group name="freightPayerRadioGroup">
                    <mat-radio-button class="matRadioButtonCustom" name="recipientRadio" value="2" (change)="changeFreightPayer(2)" color="primary">{{translation.FreightPayer}}</mat-radio-button>
                  </mat-radio-group>
                </mat-card-subtitle>
              </mat-card-content>
            </mat-card>
          </div>
          <mat-card id="vehicleCard">
            <mat-card-content class="vehicleCardContent">
              <mat-card-title class="summaryCardTitle">{{translation.Vehicles}}</mat-card-title>
              <div id="vehicleHeaderRow">
                <div class="vehicleRowItem">{{translation.Model}}</div>
                <div class="vehicleRowItem">{{translation.ChassisNumber}}</div>
                <div class="vehicleRowItem">{{translation.CommissionNumber}}</div>
                <div class="vehicleRowItem">{{translation.Mark}}</div>
                <div class="vehicleRowItem">{{translation.Color}}</div>
                <div class="vehicleRowItem">{{translation.Remarks}}</div>
                <div class="vehicleRowItem">{{translation.Special}}</div>
              </div>
              <mat-card-subtitle *ngFor="let vehicle of order.VehicleList">
                <div class="vehicleRow">
                  <div class="vehicleRowItem"><span class="material-icons" style="margin-right: 5px">directions_car</span>{{vehicle.ModelName}}</div>
                  <div class="vehicleRowItem">{{vehicle.ChassisNumber}}</div>
                  <div class="vehicleRowItem">{{vehicle.CommissionNumber}}</div>
                  <div class="vehicleRowItem">{{vehicle.License}}</div>
                  <div class="vehicleRowItem">{{vehicle.Color}}</div>
                  <div class="vehicleRowItem" *ngIf="vehicle.Comment != '' && vehicle.Comment != null">{{vehicle.Comment}}</div>
                  <div class="vehicleRowItem" *ngIf="vehicle.Comment == '' || vehicle.Comment == null">{{translation.None}}</div>
                  <div class="vehicleRowItemColumnStyle">
                    <div *ngFor="let specialSelect of vehicle.SpecialSelects">
                      <div *ngIf="specialSelect.Selected && specialSelect.Key != 7">- {{specialSelect.Value}}</div>
                    </div>
                    <div *ngIf="vehicle.SpecialTextActive">- {{vehicle.SpecialComment}}</div>
                  </div>
                </div>
              </mat-card-subtitle>
            </mat-card-content>
          </mat-card>
          <div class="lastFooterContent">
            <div class="buttonContent">
              <mat-checkbox class="buttonCheckbox" [checked]="order.ConfirmationMail" (change)="toggleConfirmationMail()" color="primary">{{translation.SendConfirmationMail}}</mat-checkbox>
              <button type="button" mat-button (click)="back()">{{translation.Back}}</button>
              <button (click)="send()" type="button" mat-button class="customButton">{{translation.Send}}</button>
            </div>
          </div>
        </div>
      </mat-step>
    </mat-stepper>
  </form>
</div>
<app-footer></app-footer>
